<div class="title">
  <h3>{{ 'select-pet-cards-modal.title'|translate }}</h3>
</div>

<div class="pet-cards-container">
  <div class="header">
    <div class="action">
      <div class="close" (click)="close()">
        <mat-icon svgIcon="cross"></mat-icon>
      </div>
    </div>
  </div>

  <cpf-pet-card-list [selectedIndexes]="selectedIndexes" [allPets]="pets"></cpf-pet-card-list>
</div>

<div class="modal-action">
  <button class="button primary text-button-small" (click)="close()">
    {{ 'select-pet-cards-modal.action-button'| translate }}
  </button>
</div>
